import React from "react";
import styles from "./ViewVideo.module.scss";
import { PlayCircleOutlined as PlayIcon } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/PlayCircleOutlined";
import { GalleryVideoObject, VideoPreloadValue } from "../../utils/utils.ts";
import { ZoomModal } from "../ZoomModal/ZoomModal";
import { dispatchGalleryMonetateQEvent } from "../Analytics/dispatchGalleryMonetateQEvent";
import { SecondaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";

export type PageProps = {
  videos: Array<GalleryVideoObject>;
  videoPreload: VideoPreloadValue;
  carouselGalleryInpTest?: boolean;
};

const ViewVideos: React.FC<PageProps> = ({
  videos,
  videoPreload,
  carouselGalleryInpTest = false,
}) => {
  const [isVideoModalOpen, setVideoModalOpen] = React.useState(false);
  const [selectedVideoIndex, setSelectedVideoIndex] = React.useState(0);

  const closeVideoModal = () => {
    setVideoModalOpen(false);
  };

  const openVideoModal = () => {
    dispatchGalleryMonetateQEvent(
      "ViewVideosButton",
      undefined,
      undefined,
      carouselGalleryInpTest,
    );
    setVideoModalOpen(true);
  };

  const videoText = "View videos";

  if (videos.length <= 1) return null;

  return (
    <>
      <SecondaryButton
        size="responsive"
        tag="button"
        type="button"
        className={styles.videoButton}
        onClick={openVideoModal}
      >
        {" "}
        <PlayIcon dataTestId="video-icon" size="large" />
        {videoText}
      </SecondaryButton>
      <ZoomModal
        closeZoomModal={closeVideoModal}
        mediaItems={videos}
        selectedIndex={selectedVideoIndex}
        setSelectedIndex={setSelectedVideoIndex}
        videoPreload={videoPreload}
        carouselGalleryInpTest={carouselGalleryInpTest}
        isZoomModalOpen={isVideoModalOpen}
      />
    </>
  );
};

export { ViewVideos as ViewVideos };
